import bs58 from "bs58";
function base64encode(data: Buffer): string {
    return data.toString("base64");
}

function base64Decode(data: string): Buffer {
    return Buffer.from(data, "base64");
}

function base58encode(data: Buffer | Uint8Array): string {
    return bs58.encode(new Uint8Array(data));
}

function base58Decode(data: string): Buffer {
    return Buffer.from(new Uint8Array(bs58.decode(data)));
}

export const base64 = { encode: base64encode, decode: base64Decode };
export const base58 = { encode: base58encode, decode: base58Decode };
